<template>
  <v-container>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn text fab @click="$router.go(-1)">
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{getMatutina.libro.tipo}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <h1 class="text-uppercase text-center mb-4">{{getMatutina.titulo}}</h1>
        <p class="subtitle-1 text-center">{{getMatutina.libro.titulo}}</p>
        <p class="subtitle-2 text-center">{{fecha}}</p>
        <blockquote class="blockquote text-center">{{versiculo}}</blockquote>
        <div v-html="contenido"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
dayjs.extend(customParseFormat)
export default {
  data () {
    return {
      contenido: '',
      versiculo: ''
    }
  },
  beforeMount () {
    if (!this.getMatutina) {
      this.$router.push({ name: 'main' })
    }
    const lines = this.getMatutina.contenido.split('\n')
    this.versiculo = lines.shift()
    this.contenido = lines.map(i => `<p>${i}</p>`).join('')
  },
  computed: {
    ...mapGetters(['getMatutina']),
    fecha () {
      return this.getMatutina && this.getMatutina.fecha ? dayjs(this.getMatutina.fecha.split('T')[0], 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    }
  }
}
</script>

<style scoped>
.toolbar-title {
  color: white;
  text-decoration: none;
}
</style>
